export default {"src":"/_next/static/media/Insurance.877ce8e9.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};